"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HelperUtils_1 = require("utils/HelperUtils");
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const TooltipContainer_1 = __importDefault(require("components/shared/Tooltips/TooltipContainer"));
const SVGWithTooltip = ({ text, action, iconName, customClass, isColumn = false }) => {
    return (react_1.default.createElement(TooltipContainer_1.default, { show: true, position: "top", classContainer: customClass, text: (0, HelperUtils_1.getObjectiveLocale)(text) },
        react_1.default.createElement("div", { className: isColumn ? 'w-[32px] h-[32px]' : '', style: {
                background: isColumn
                    ? 'linear-gradient(270deg, #FFFFFF 50%, rgba(255, 255, 255, 0.64) 100%)'
                    : ''
            } },
            react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: iconName, fillColor: "var(--n-600)", onClick: action }))));
};
exports.default = SVGWithTooltip;
